var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "bg-white-10 skew-sm-30 skew-15 my-4 py-4 px-xl-18 px-lg-14 px-sm-10 px-5"
      },
      [
        _c(
          "div",
          { staticClass: "bg-white-20 skew-inner py-4 px-sm-10 px-6" },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "div",
                { staticClass: "col-16" },
                [
                  _c(
                    "swiper",
                    {
                      ref: "swiper",
                      staticClass: "exclusivities-carousel",
                      attrs: { options: _vm.swiperOptions }
                    },
                    _vm._l(_vm.slides, function(slide, index) {
                      return _c("swiper-slide", { key: index }, [
                        _c("img", { attrs: { src: slide, alt: slide } })
                      ])
                    }),
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }